import React, { useState, useContext, useEffect } from "react";
import styles from "./SwitchPopup.module.css";
import { toast } from "react-toastify";
import { Modal, Button, Form, Row, Col, Container } from "react-bootstrap";
import VideoContext from "../../store/video-context";

const SwitchPopup = (props: any) => {
  const vContext = useContext(VideoContext);
  const [show, setShow] = useState(false);
  const [validated, setValidated] = useState(false);
  const [checkyes, setCheckyes] = useState(true);
  const [check, setCheck] = useState([
    {
      name: "check-1",
      key: "checkbox-1",
      label: "Video is not loading",
      isSelected: false,
    },
    {
      name: "check-2",
      key: "checkbox-2",
      label: "Getting 'Stream Unavailable' message",
      isSelected: false,
    },
    {
      name: "check-3",
      key: "checkbox-3",
      label: "Frequently getting 'buffering' message",
      isSelected: false,
    },
  ]);
  const [desc, setDesc] = useState("");

  // const handleClose = () => setShow(false);
  const handleClose = () => {
    console.log("san");
    props.hide();
  };
  const handleShow = () => setShow(true);

  const SwithToOldApi = () => {
    let reasonData = "";
    check.forEach((item: any) => {
      if (item.isSelected) {
        reasonData = reasonData + item.label + " <br> ";
      }
    });
    reasonData = reasonData + desc;

    console.log("reasonData" + reasonData);

    let data: { [index: string]: any } = { command: "sendPlayerIssueMail" };
    data.transID = vContext.transId;
    data.userID = vContext.userId;
    data.reason = reasonData;
    fetch("https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data), //JSON.stringify({a: 1, b: 'Textual content'})
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "success") {
          // implement redirection logic here
         // console.log("dd...", result);
        // window.open(window.location.origin + "/" + result.data.url, "_self");
         handleClose();
          toast.dark("Our team will get in touch with you soon. In the mean time, please try switching to better Internet connection", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          // console.log("product enquiry failed");
          toast.dark("Something went wrong!", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch((error) => {
        console.error("Error:(SwithToOldApi)", error);
      });
    console.log("check", data);
  };

  //console.log("check" + check1);
  const check_total = (e: any) => {
    console.log("testevent", e);
    let test = check;
    // console.log("testevent",test.map((c: any) => c.name === e.target.id ? { ...c, isSelected: !e.target.checked } : c));
    // setCheck({ ...check, [e.target.name]: e.target.checked });
    setCheck((existing: any) =>
      existing.map((c: any) =>
        c.name === e.target.id ? { ...c, isSelected: e.target.checked } : c
      )
    );
  };

  const get_desc = (e: any) => {
    setDesc(e.target.value);
  };

  const handleSubmit = (e: any) => {
    let reasonData = "";
    check.forEach((item: any) => {
      if (item.isSelected) {
        reasonData = reasonData + item.label + " <br> ";
      }
    });
    if (reasonData == "") {
      if (desc == "") {
        setCheckyes(false);
      } else {
        setCheckyes(true);
        SwithToOldApi();
      }
    } else {
      setCheckyes(true);
      SwithToOldApi();
    }
  };

  return (
    <>
      <Modal.Header
        closeButton
        style={{ backgroundColor: "#087CB9", color: "White" }}
      >
        <Modal.Title>Kindly select appropriate option(s)</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      {checkyes ? (
            ""
          ) : (
            <div
              style={{
                color: "#dc3545",
            
                marginBottom: "1em",
                fontSize: "80%",
                fontFamily: "default",
              }}
            >
              Please select a valid reason or add description.
            </div>
          )}

  
        <Form onSubmit={handleSubmit} noValidate validated={validated}>
          {check.map((item: any) => {
            return (
              <Form.Check
                type="checkbox"
                id={item.name}
                label={item.label}
                onChange={check_total}
              />
            );
          })}
                  <br />
          <Form.Group controlId="desc">
            <Form.Control
              as="textarea"
              placeholder="Add Description"
              id="desc"
              onChange={get_desc}
            ></Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button type="submit" variant="primary" onClick={handleSubmit}>
          Submit
        </Button>
      </Modal.Footer>
    </>
  );
};
export default SwitchPopup;
